import { Component, Prop, Vue } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';

/**
 * 路由项
 */
@Component({ name: 'RouteItem' })
export default class extends Vue {
    /**
     * 路由配置
     */
    @Prop({ required: true }) public route!: RouteConfig;

    /**
     * 标题
     */
    public get title() {
        return this.$utils.getValueByPath(this.route, 'meta.title');
    }

    /**
     * icon
     */
    public get icon() {
        return this.$utils.getValueByPath(this.route, 'meta.icon');
    }

    /**
     * 跳转
     */
    public navigate() {
        if (this.route.name !== this.$route.name) {
            this.$router.replace({ name: this.route.name });
        }
    }
}
